export default "__VITE_ASSET__Cqr2gw3F__"